import firebase from 'firebase/app';

export const createSetupIntent = async () => {
  const setupIntent = await firebase
    .functions()
    .httpsCallable('createSetupIntent')();

  return setupIntent.data;
};
